<h1 class="abilHeader">
  {{ header() || "" | translate }}
</h1>
@if (bold1()){
<div class="list">
  <span class="rectangle"></span>
  <p class="abilText">
    <a [href]="link1()" target="_blank"
      ><span class="abilBold">{{ bold1() || "" | translate }}</span></a
    >
    {{ text1() || "" | translate }}
  </p>
</div>
} @if (bold2()) {
<div class="list">
  <span class="rectangle"></span>
  <p class="abilText">
    <a [href]="link2()" target="_blank">
      <span class="abilBold">{{ bold2() || "" | translate }}</span></a
    >
    {{ text2() || "" | translate }}
  </p>
</div>
}
